import * as components from './components';
import VueSanitize from 'vue-sanitize';
import vmodal from 'vue-js-modal';
import VueSocialSharing from 'vue-social-sharing';
import VTooltip from 'v-tooltip';
import { setInteractionMode } from 'vee-validate';

setInteractionMode('eager');

let VueSanitizeOptions = VueSanitize.defaults;
VueSanitizeOptions.allowedTags = [
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'blockquote',
    'p',
    'a',
    'ul',
    'ol',
    'nl',
    'li',
    'b',
    'i',
    'strong',
    'em',
    'strike',
    'code',
    'hr',
    'br',
    'div',
    'table',
    'thead',
    'caption',
    'tbody',
    'tr',
    'th',
    'td',
    'pre',
    'img',
];
VueSanitizeOptions.allowedAttributes.img = ['src', 'width', 'height', 'style'];

const SalesChannelComponents = {
    install(Vue, options = {}) {
        if (options) {
            // Options needs to be passed
        }

        const events = new Vue({ name: 'Scc' });

        const navigate = route => {
            events.$emit('navigate', route);
        };

        // TODO: Add events to prototype

        Vue.prototype.$scc = { navigate };
        Vue.use(VueSanitize, VueSanitizeOptions);
        Vue.use(vmodal);
        Vue.use(VueSocialSharing);
        Vue.use(VTooltip, {
            defaultHtml: false,
            defaultClass: 'scc-tooltip',
        });

        for (const componentName in components) {
            const component = components[componentName];
            Vue.component(component.name, component);
        }
    },
};

export { components };

export default SalesChannelComponents;
